import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetTotalDischargesRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string(),
  to: z.string(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
});

const GetTotalDischargesResponseDtoSchema = z.object({
  marketMedian: z.number().nullable(),
  currentValue: z.number().nullable(),
  hint: z.string(),
  message: z.string(),
});

export type GetTotalDischargesRequestDto = z.infer<
  typeof _GetTotalDischargesRequestDtoSchema
>;
export type GetTotalDischargesResponseDto = z.infer<
  typeof GetTotalDischargesResponseDtoSchema
>;

export const getTotalDischargesKpi = async (
  params: GetTotalDischargesRequestDto,
  config?: AxiosRequestConfig<GetTotalDischargesRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`/market-intelligence/facilities/${facilityId}/total-discharges-kpi`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetTotalDischargesResponseDtoSchema));
};
